import React, { useState } from "react";

const noticesData = [
  {
    title: "Final Exam Timetable Released",
    date: "12 Apr 2026",
    category: "Exam Schedules",
  },
  {
    title: "Summer Vacation Starts Soon",
    date: "10 Apr 2026",
    category: "Holidays",
  },
  {
    title: "Sports Day Registration Open",
    date: "08 Apr 2026",
    category: "Events",
  },
  {
    title: "New Library Books Available",
    date: "05 Apr 2026",
    category: "Important Updates",
  },
  {
    title: "Independence Day Holiday Notice",
    date: "03 Apr 2026",
    category: "Holidays",
  },
];

export default function Notices() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredNotices =
    activeCategory === "All"
      ? noticesData
      : noticesData.filter(
        (notice) => notice.category === activeCategory
      );

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Segoe UI', sans-serif;
        }

        .notice-page {
          padding: 40px;
          background: #f4f6f9;
          min-height: 100vh;
        }

        /* =========================
           HEADER
        ========================= */
        .notice-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .notice-title {
          font-size: 34px;
          font-weight: 700;
          color: #1e3a8a;
        }

        /* =========================
           CATEGORY BUTTONS
        ========================= */
        .category-bar {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .category-btn {
          background: white;
          border: 1px solid #d1d5db;
          padding: 10px 18px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .category-btn.active {
          background: #1e3a8a;
          color: white;
          border-color: #1e3a8a;
        }

        .category-btn:hover {
          background: #1e3a8a;
          color: white;
        }

        /* =========================
           TABLE CONTAINER
        ========================= */
     .notice-table-container {
  background: white;
  border-radius: 18px;

  width: 100%;
  max-height: 300px;

  overflow-x: auto;
  overflow-y: auto;

  box-shadow: 0 5px 18px rgba(0,0,0,0.08);

  scroll-behavior: smooth;

  /* IMPORTANT FOR MOBILE */
  -webkit-overflow-scrolling: touch;
}

/* FORCE SCROLL */
.notice-table-container table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
}
 /* FIREFOX */
  scrollbar-width: thin;
  scrollbar-color: #1e3a8a #f1f1f1;
}

/* =========================
   DESKTOP SCROLLBAR
========================= */
.notice-table-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.notice-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notice-table-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 700px;
        }

        thead {
          background: #1e3a8a;
          color: white;
        }

        th {
          padding: 18px 16px;
          text-align: left;
          font-size: 15px;
          font-weight: 600;
        }

        td {
          padding: 16px;
          font-size: 15px;
        }

        tbody tr {
          border-bottom: 1px solid #e5e7eb;
          transition: 0.2s;
        }

        tbody tr:hover {
          background: #f9fafb;
        }

        .serial {
          width: 70px;
          text-align: center;
          color: #6b7280;
          font-weight: 600;
        }

        .notice-text {
          font-weight: 600;
          color: #111827;
        }

        .notice-date {
          color: #374151;
          font-size: 14px;
          white-space: nowrap;
        }

        /* =========================
           BADGES
        ========================= */
        .badge {
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          display: inline-block;
          white-space: nowrap;
        }

        .important {
          background: #fee2e2;
          color: #b91c1c;
        }

        .events {
          background: #dcfce7;
          color: #166534;
        }

        .holidays {
          background: #e0f2fe;
          color: #0369a1;
        }

        .exam {
          background: #fef3c7;
          color: #92400e;
        }

        /* =========================
           LARGE TABLET
        ========================= */
@media (max-width: 768px) {

  .notice-table-container {
    max-height: 250px;
  }

  .notice-table-container table {
    min-width: 700px;
  }

}

        /* =========================
           TABLET
        ========================= */
        @media (max-width: 768px) {
          .notice-page {
            padding: 25px 18px;
          }

@media (max-width: 768px) {

  .notice-table-container {
    max-height: 250px;
  }

  .notice-table-container table {
    min-width: 700px;
  }

}
          .notice-header {
            flex-direction: column;
            align-items: flex-start;
          }

          .notice-title {
            font-size: 26px;
          }

          .category-bar {
            width: 100%;
            gap: 10px;
          }

          .category-btn {
            flex: 1 1 calc(50% - 10px);
            text-align: center;
          }

          table {
            min-width: 650px;
          }

          th,
          td {
            padding: 14px;
            font-size: 14px;
          }
        }

        /* =========================
           MOBILE
        ========================= */
        @media (max-width: 480px) {
          .notice-page {
            padding: 20px 12px;
          }

          .notice-title {
            font-size: 22px;
            line-height: 1.4;
          }

          .category-bar {
            flex-direction: column;
            width: 100%;
          }

          .category-btn {
            width: 100%;
            padding: 12px;
            font-size: 14px;
          }

    @media (max-width: 480px) {

  .notice-table-container {
    max-height: 220px;
  }

  .notice-table-container table {
    min-width: 650px;
  }

}

          table {
            min-width: 600px;
          }

          th,
          td {
            padding: 12px;
            font-size: 13px;
          }

          .badge {
            font-size: 11px;
            padding: 5px 10px;
          }
        }
      `}</style>

      <div className="notice-page">
        <div className="notice-header">
          <div className="notice-title">Notices & Announcements</div>

          {/* Category Buttons */}
          <div className="category-bar">
            {["All", "Important Updates", "Events", "Holidays", "Exam Schedules"].map(
              (cat) => (
                <button
                  key={cat}
                  className={`category-btn ${activeCategory === cat ? "active" : ""
                    }`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              )
            )}
          </div>
        </div>

        <div className="notice-table-container">
          <table>
            <thead>
              <tr>
                <th className="serial">#</th>
                <th>Notice Title</th>
                <th>Date</th>
                <th>Category</th>
              </tr>
            </thead>

            <tbody>
              {filteredNotices.map((notice, index) => {
                let badgeClass = "";

                if (notice.category === "Important Updates") badgeClass = "important";
                if (notice.category === "Events") badgeClass = "events";
                if (notice.category === "Holidays") badgeClass = "holidays";
                if (notice.category === "Exam Schedules") badgeClass = "exam";

                return (
                  <tr key={index}>
                    <td className="serial">{index + 1}</td>
                    <td className="notice-text">{notice.title}</td>
                    <td className="notice-date">{notice.date}</td>
                    <td>
                      <span className={`badge ${badgeClass}`}>
                        {notice.category}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}